import { render, staticRenderFns } from "./CustomerDetailFreeChargingPoints.vue?vue&type=template&id=4fed0980"
import script from "./CustomerDetailFreeChargingPoints.vue?vue&type=script&lang=js"
export * from "./CustomerDetailFreeChargingPoints.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailFreeChargingPoints.vue?vue&type=style&index=0&id=4fed0980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports